module.exports = __webpack_public_path__ + "img/cancel_detail.0f68aa0f.svg";